import React from 'react';
import PropTypes from 'prop-types';

import TimedInputBase from './base.jsx';
import TextInput from 'zoomforth_component_lib/basic_text_input.jsx';

const TimedTextInput = ({ 
  onChangeTimerMs, 
  onChange, 
  onEveryChange,
  value, 
  ...rest 
})=> (
  <TimedInputBase
    value={value}
    onChange={onChange}
    onEveryChange={onEveryChange}
    onChangeTimerMs={onChangeTimerMs}
    getOnChangeValue={(e) => e.target.value}
  >
    <TextInput { ...rest } />
  </TimedInputBase>
);

TimedTextInput.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onEveryChange: PropTypes.func,
  onChangeTimerMs: PropTypes.number
};

export default TimedTextInput;